/**
 * 首页我的信息模块
 * @author yongsheng.zhang
 */
const $ = require('jquery');
const Cookie = require('../../../lib/cookie.js');
// const Cookie = require('../../../lib/cookie.js').default;
const LXBid = require('../../../lib/lx-bid.js')
const LXWrap = require('../../../lib/lx.js')
const Domain = location.href.indexOf('51ping') !== -1 ? '//w.51ping.com' : '//www.dianping.com';
const Rohr = require('../../../lib/rohr.js')

let param = {
    isLogin: false,
    hello: new Date().getHours() > 12 ? (new Date().getHours() > 18 ? '晚上好' : '下午好') : '上午好',
    userInfo: {},
    cityId: window._DP_HeaderData && window._DP_HeaderData.cityId ? window._DP_HeaderData.cityId : 1,
    userId: window._DP_HeaderData && window._DP_HeaderData.userId ? window._DP_HeaderData.userId : null
}
let timeing = window.performance ? window.performance.timing.navigationStart : _start
let uuid = Cookie.readCookie('_lxsdk_cuid') || '' // 反爬虫用

let valLab = {
    'custom': {
        'city_id': param.cityId,
        'user_id': param.userId
    }
}

// 个人信息点击 未登录态
LXWrap($('#userinfo .opt-btn'), LXBid.noLoginClickBid, true, false, true, true)
/**
 * 获取用户信息
 */
const myInfo = () => {
    let $userinfo = $('#userinfo');
    let $vip = $('#vip-info');
    $userinfo.find('.hello').html(param.hello);
    // 增加反爬虫人机识别
    let ajaxUrlToken
    try {
        ajaxUrlToken = Rohr(`${Domain}/ajax/userinfo`, {uuid: uuid,
            platform: 1,
            partner: 150,
            originUrl: location.href
        })
    } catch (e) {
        console.log('rohr error')
    }
    $.ajax({
        url: `${Domain}/ajax/userinfo`,
        type: 'GET',
        dataType: 'json',
        data: {
            uuid: uuid,
            platform: 1,
            partner: 150,
            originUrl: location.href,
            _token: ajaxUrlToken
        }
    })
        .then(result => {
            if (result && result.code === 200 && result.msg) {
                param.isLogin = result.msg.isLogined;
                // userinfo为空对象时显示未登录
                if (param.isLogin) {
                    let $login = $userinfo.find('.user-opt-login')
                    if (!result.msg.userInfo || !result.msg.userInfo.userId) {
                        $userinfo.find('.use-day').html(`<span>欢迎使用大众点评</span>`)
                    } else {
                        let vipLevel = result.msg.userInfo.vipLevel
                        let className = ''
                        if (vipLevel === 1) {
                            className = 'viper'
                        } else if (vipLevel === 0) {
                            className = 'no-viper'
                        }
                        $userinfo.find('.user-pic .user').attr('src', result.msg.userInfo.userFace)
                        $userinfo.find('.user-pic .user-link').attr('href', `/member/${result.msg.userInfo.userId}`)
                        let nameDom = `<span class="hello">${param.hello},</span>
                                        <a href="/member/${result.msg.userInfo.userId}">
                                            <span class="hi-name">${result.msg.userInfo.userNickName}</span>
                                        </a>
                                        <span class="user-level level-${result.msg.userInfo.userLevel}"></span>
                                        <span class="${className}"></span>`
                        $userinfo.find('.hello-user').html(nameDom)
                        $userinfo.find('.use-day').html(`<span>您已使用大众点评</span><span class="days-count">${result.msg.userInfo.useDpDays}</span><span>天</span>`)
                        $login.find('.collect').attr('href', `/member/${result.msg.userInfo.userId}/wishlists`)
                    }
                    $login.find('.review-hold .info-count').text(`${result.msg.waitCommonCount ? result.msg.waitCommonCount : 0}`)
                    $login.find('.collect .info-count').text(`${result.msg.favorShopCount ? result.msg.favorShopCount : 0}`)
                    $login.find('.coupon .info-count').text(`${result.msg.dealCount ? result.msg.dealCount : 0}`)
                    $userinfo.find('.user-opt-login').removeClass('Hide').siblings('.user-opt-nologin').css('height', 0)
                    // 个人信息view 登录态
                    LXWrap($('#userinfo .user-opt-login'), LXBid.userInfoViewBid, true, true)
                    // 个人信息点击 登录态
                    LXWrap($('#userinfo .user-link'), LXBid.userInfoClickBid, true, false)
                    LXWrap($('#userinfo .info-detail'), LXBid.userInfoClickBid, true, false)
                } else {
                    // 个人信息view打点 未登录
                    LXWrap($('#userinfo .user-opt-nologin'), LXBid.noLoginViewBid, true, true)
                    // $userinfo.find('.hello').html(param.hello);
                }
                try {
                    Owl.addPoint({
                        position: 2,
                        duration: +new Date() - timeing
                    })
                    Owl.sendPoints();
                } catch (e) {
                    console.log('olw addpoint 2 myinfo error');
                }
                console.log('myinfo success');
            } else {
                // 个人信息view打点 未登录
                LXWrap($('#userinfo .user-opt-nologin'), LXBid.noLoginViewBid, true, true)
            }
        }, err => {
            // 个人信息view打点 未登录
            LXWrap($('#userinfo .user-opt-nologin'), LXBid.noLoginViewBid, true, true)
            try {
                Owl.addError({
                    name: 'ajax接口错误',
                    msg: 'userinfo' + '返回结果：' + JSON.stringify(err)
                })
            } catch (e) {
                console.log('owl userinfo error');
            }
            if (err) {
                console.log('myinfo fail');
            }
        });
    // 热帖曝光
    let len = $('.hot-post').find('.post-item').length
    if (len) {
        // 热帖曝光
        LXWrap($('.hot-post'), LXBid.postViewBid, false, true)
    }
    // 热帖区域点击打点
    LXWrap($('.post-item'), LXBid.postClickBid, false, false, false)
    // vip排行点击打点
    LXWrap($('.vip-item'), LXBid.vipClickBid, false, false, false)
    // 部落点击打点
    LXWrap($('.tribe-item'), LXBid.tribeClickBid, false, false, false)
    // 分类标题点击打点
    LXWrap($('.vip-info-title .info-title'), LXBid.socialInfoClickBid, true, false)
    // hover vip title
    $vip.find('.info-title').on('mouseover', function(e) {
        let dataInfo = $(this).attr('data-info');
        if (!$(this).hasClass('current')) {
            switch (dataInfo) {
            case 'vip-star':
                // vip排行view打点
                LXWrap($('.vip-star'), LXBid.vipViewBid, false, true)
                break;
            case 'tribe':
                LXWrap($('.tribe'), LXBid.tribeViewBid, false, true)
                break;
            default :
                LXWrap($('.hot-post'), LXBid.postViewBid, false, true)
                break;
            }
        }
        $vip.find('.info-title').removeClass('current');
        $(this).addClass('current');
        $vip.find('.info-detail').addClass('Hide');
        $vip.find(`.${dataInfo}`).removeClass('Hide');
    });
    $vip.find('.vip-item').on('mouseover', function(e) {
        $(this).find('.vip-overlay').removeClass('Hide');
    });
    $vip.find('.vip-item').on('mouseleave', function(e) {
        $(this).find('.vip-overlay').addClass('Hide');
    });
    $vip.find('.tribe-item').on('mouseover', function(e) {
        $(this).find('.vip-overlay').removeClass('Hide');
    });
    $vip.find('.tribe-item').on('mouseleave', function(e) {
        $(this).find('.vip-overlay').addClass('Hide');
    });
    // 处理头条文字过多
    let headlineIndex = $('.headline .headline-link').length;
    if (headlineIndex) {
        // 点评头条点击打点
        LXWrap($('.headline-link'), LXBid.headlineClickBid, true, false)

        // 点评头条曝光打点
        LXWrap($('.headline'), LXBid.headlineViewBid, true, true)

        $('.headline .headline-link').each((index, item) => {
            let s = $(item).find('.headline-con');
            if (s.html().trim().length > 18) {
                s.addClass('over-word');
            }
        });
    }
    // 头条滚动
    const sliderPicture = () => {
        if (headlineIndex < 2) return;
        let $this = $('.headline-item');
        let $link = $this.find('a');
        let height = $this.height();
        let auto = 3000
        $this.addClass('jPicture-container').children().first().addClass('jPicture-inner').children().addClass('jPicture-part');
        // 设置初始图片索引为 0
        $this.on('selectstart', function() {
            return false;
        }).attr('data-cacheIndex', 0);
        let $inner = $this.find('.jPicture-inner');
        // let $part = $this.find('.jPicture-part');
        let LineSize = $inner.find('a').length;
        let $Part = $inner.find('.headline-link');
        let $partFirst = $Part.first();
        let $partLast = $Part.last();
        $inner.addClass('jPicture-slide').height(height * (LineSize + 2)).append($partFirst.clone(true)).prepend($partLast.clone(true)).css('top', -height + 'px');
        // 设定统一的图片切换动画过渡时间为 700ms
        var time = 700;
        // 动画元素
        function Animation(i) {
            $.easing.easeInOutQuart = function(x, t, b, c, d) {
                return ((t /= d / 2) < 1) ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b;
            }
            if (!$inner.is(':animated')) {
                $inner.stop().animate({
                    top: -(height * i + height) + 'px'
                }, time, 'easeInOutQuart', function() {
                    if (i === -1) {
                        $inner.css('top', '-' + height * LineSize + 'px');
                        i = LineSize - 1;
                    }
                    if (i === LineSize) {
                        $inner.css('top', '-' + height + 'px');
                        i = 0;
                    }
                    $this.attr('data-cacheIndex', i);
                    $link.removeClass('jPicture-pointerevents-none');
                });
            }
        }
        // 自动执行动画
        let getIndex;
        if (auto && typeof auto === 'number') {
            let autoAnimate = setInterval(function() {
                getIndex = $this.attr('data-cacheIndex')
                getIndex++
                Animation(getIndex)
            }, auto);
            $this.mouseenter(function() {
                clearInterval(autoAnimate);
            }).mouseleave(function() {
                autoAnimate = setInterval(function() {
                    getIndex = $this.attr('data-cacheIndex');
                    getIndex++;
                    Animation(getIndex);
                }, auto);
            })
        }
    }
    sliderPicture()
    // 点评头条点击打点
    LXWrap($('.headline-item'), LXBid.headlineClickBid, true, false, false)
}

module.exports = myInfo



// WEBPACK FOOTER //
// ./src/pages/index/component/my-info.js